import React from 'react';
import PropTypes from 'prop-types';
import './FlipCard.css';

function FlipCardContainerComponent({ children, flip, transform }) {
  const classes = `flip-container${flip ? ' flip' : ''}${transform ? ' transform' : ''}`;
  return (
    <div className={classes}>
      {children}
    </div>
  );
}

FlipCardContainerComponent.propTypes = {
  children: PropTypes.arrayOf(PropTypes.element),
  flip: PropTypes.bool,
  transform: PropTypes.bool,
};

export default FlipCardContainerComponent;



// WEBPACK FOOTER //
// ./src/components/FlipCard/FlipCardContainer.js